/**
 * Created by jonas on 2021-11-19.
 */

export class LayersSet {

    // hackjob gaming
    public maskedNormal:PIXI.Container;
    public maskedM1:PIXI.Container;
    public maskedScatters:PIXI.Container;
    public maskedWinCap:PIXI.Container; // WinCap symbol
    public maskedOver:PIXI.Container;
    // Container used by xNudge symbols during spin in order to hide padding symbols behind it
    public xNudgeSpinContainer:PIXI.Container;
    public maskedHighlight:PIXI.Container;
    public win:PIXI.Container;
    public winOver:PIXI.Container;
    public overlay:PIXI.Container;

    public all:PIXI.Container[];

    constructor(namePrefix:string = "", nameSuffix:string = "") {
        this.maskedNormal = new PIXI.Container();
        this.maskedM1 = new PIXI.Container();
        this.maskedScatters = new PIXI.Container();
        this.maskedWinCap = new PIXI.Container();
        this.maskedOver = new PIXI.Container();
        this.maskedHighlight = new PIXI.Container();
        this.win = new PIXI.Container();
        this.winOver = new PIXI.Container();
        this.overlay = new PIXI.Container();

        this.maskedNormal.name = `${namePrefix}normal${nameSuffix}`;
        this.maskedM1.name = `${namePrefix}M1${nameSuffix}`;
        this.maskedScatters.name = `${namePrefix}scatter${nameSuffix}`;
        this.maskedWinCap.name = `${namePrefix}winCap${nameSuffix}`;
        this.maskedOver.name = `${namePrefix}maskedOver${nameSuffix}`;
        this.maskedHighlight.name = `${namePrefix}maskedHighlight${nameSuffix}`;
        this.win.name = `${namePrefix}win${nameSuffix}`;
        this.winOver.name = `${namePrefix}winOver${nameSuffix}`;
        this.overlay.name = `${namePrefix}overlay${nameSuffix}`;
        this.all = [
            this.maskedNormal,
            this.maskedM1,
            this.maskedScatters,
            this.maskedOver,
            this.maskedWinCap,
            this.maskedHighlight,
            this.win,
            this.winOver,
            this.overlay,
        ];
    }

    public addLayerSet(layerSet:LayersSet) {
        this.maskedNormal.addChild(layerSet.maskedNormal);
        this.maskedOver.addChild(layerSet.maskedOver);
        this.maskedHighlight.addChild(layerSet.maskedHighlight);
        this.win.addChild(layerSet.win);
        this.winOver.addChild(layerSet.winOver);
        this.overlay.addChild(layerSet.overlay);
    }


}